
import React from 'react';
import { Job } from "@/components/jobs/types";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface JobLocationFieldProps {
  job: Pick<Job, 'location'>;
  isEditing: boolean;
  formDataLocation: string | undefined;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const JobLocationField: React.FC<JobLocationFieldProps> = ({ job, isEditing, formDataLocation, onInputChange }) => {
  return (
    <div>
      <Label htmlFor="location" className="text-xs font-medium text-muted-foreground">Location</Label>
      {isEditing ? (
        <Input
          id="location"
          name="location"
          value={formDataLocation || ''}
          onChange={onInputChange}
          placeholder="e.g. San Francisco, CA"
          className="text-sm"
        />
      ) : (
        <p>{job.location || 'N/A'}</p>
      )}
    </div>
  );
};
